import { render, staticRenderFns } from "./TeacherTree.vue?vue&type=template&id=496349cc"
import script from "./TeacherTree.vue?vue&type=script&lang=js"
export * from "./TeacherTree.vue?vue&type=script&lang=js"
import style0 from "./TeacherTree.vue?vue&type=style&index=0&id=496349cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports